import { render, staticRenderFns } from "./getDayDiaresPage.vue?vue&type=template&id=cf2ac9b6&scoped=true"
import script from "./getDayDiaresPage.vue?vue&type=script&lang=js"
export * from "./getDayDiaresPage.vue?vue&type=script&lang=js"
import style0 from "./getDayDiaresPage.vue?vue&type=style&index=0&id=cf2ac9b6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2ac9b6",
  null
  
)

export default component.exports